import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/** Banner CTA opens the opt-in modal; the modal owns rendering. */
export const heidi2OptInModalOpenAtom = atom(false);

/** Non-admin counterpart of the opt-in modal: asks workspace admins for Heidi II. */
export const heidi2RequestAccessModalOpenAtom = atom(false);

/**
 * True while the Heidi II first-run or relaunch takeover is showing (or about
 * to). Writers: the awareness banner (first-run) and the relaunch host.
 * Readers: launch modals that must not compete with the takeover — Session
 * Merge onboarding peeks through the takeover's inset margin otherwise.
 */
export const heidi2OnboardingOpenAtom = atom(false);

/**
 * Dev-tools preview of the explore-later nudges. When set, the audience is
 * treated as a Heidi II clinician who took that route through the welcome, so
 * the nudges can be checked without resetting a real account. Only the
 * dev-tools section writes it; closes still persist as they would for real.
 * Kept in sessionStorage so a refresh stays in the preview until it is stopped.
 */
export const heidi2ExploreLaterPreviewAtom = atomWithStorage<
  'skipped' | 'completed' | null
>(
  'heidi-2-explore-later-preview',
  null,
  createJSONStorage<'skipped' | 'completed' | null>(() => sessionStorage)
);

/**
 * When the dev-tools preview last started, as an ISO string. Stands in for the
 * welcome's first view, so the checklist only ticks what is done after it.
 */
export const heidi2ExploreLaterPreviewStartedAtAtom = atomWithStorage<string | null>(
  'heidi-2-explore-later-preview-started-at',
  null,
  createJSONStorage<string | null>(() => sessionStorage)
);

/**
 * Bumped by the dev-tools restart. The nudges key on it, so anything they
 * closed locally this session comes back instead of staying hidden.
 */
export const heidi2ExploreLaterRestartAtom = atom(0);
